import React from 'react';
import f from './Filters.module.css';
import { getGroupAvailableBranches, resolveSelectedGroupBranches, toggleValue } from '../../utils/dashboardFilters';

/* Filtro global de grupos de sucursales (selección múltiple).
   Los grupos seleccionados se combinan con OR entre sí; con las demás dimensiones se combinan con AND. */
export default function GroupFilter({ groups, loading, error, onRetry, selectedIds, onChange, canManage, onManage }) {
  const { branches, emptyGroups } = resolveSelectedGroupBranches(groups, selectedIds);
  const selectedGroups = groups.filter((group) => selectedIds.includes(group.id));

  return (
    <div className={f.field} data-testid="group-filter" data-tour="group-filter">
      <span className={f.label}>Grupos</span>

      {loading && <span className={f.hint} role="status">Cargando grupos…</span>}

      {!loading && error && (
        <div className={f.error} role="alert">
          <span>{error}</span>
          <button type="button" className={f.linkBtn} onClick={onRetry}>Reintentar</button>
        </div>
      )}

      {!loading && !error && groups.length === 0 && (
        <span className={f.hint}>
          Aún no hay grupos de sucursales.{' '}
          {canManage && <button type="button" className={f.linkBtn} onClick={onManage}>Crear un grupo</button>}
        </span>
      )}

      {groups.length > 0 && (
        <div className={f.chips} role="group" aria-label="Grupos de sucursales">
          {groups.map((group) => {
            const active = selectedIds.includes(group.id);
            const available = getGroupAvailableBranches(group).length;
            // A group with no available branch cannot be newly selected (a selected one can always be cleared)
            const disabled = available === 0 && !active;
            return (
              <button
                key={group.id}
                type="button"
                className={`${f.chip} ${active ? f.chipActive : ''}`}
                aria-pressed={active}
                disabled={disabled}
                title={available === 0 ? 'Este grupo no tiene sucursales disponibles' : undefined}
                onClick={() => onChange(toggleValue(selectedIds, group.id))}
              >
                <span>{group.name}</span>
                <span className={f.chipCount}>{available}</span>
              </button>
            );
          })}
        </div>
      )}

      {selectedGroups.length > 0 && (
        <div className={f.includes} data-testid="group-includes">
          {selectedGroups.map((group) => {
            const names = getGroupAvailableBranches(group).map((branch) => branch.name);
            return (
              <div key={group.id}>
                <strong>{group.name}</strong> incluye:{' '}
                {names.length > 0 ? names.join(', ') : 'ninguna sucursal disponible'}
              </div>
            );
          })}
          {selectedGroups.length > 1 && branches.length > 0 && (
            <div>Total sin repetir: {branches.length} {branches.length === 1 ? 'sucursal' : 'sucursales'}</div>
          )}
        </div>
      )}

      {emptyGroups.length > 0 && (
        <div className={f.warn} role="alert">
          {emptyGroups.map((group) => group.name).join(', ')}: sin sucursales disponibles, no aporta datos al filtro.
        </div>
      )}

      {selectedGroups.length > 0 && (
        <span className={f.hint}>
          Con grupos seleccionados solo cuentan los grupos. Quita los grupos para volver a elegir sucursales una a una.
        </span>
      )}

      {canManage && groups.length > 0 && (
        <button type="button" className={f.linkBtn} onClick={onManage}>Administrar grupos</button>
      )}
    </div>
  );
}
